<template>
  <section class="top-stat-loader section section--lg" aria-hidden="true">
    <v-container>
      <v-skeleton-loader class="top-stat-loader-header" type="heading" />
      <v-row class="top-stat-loader-grid">
        <v-col v-for="index in 4" :key="index" cols="12" sm="6" md="3">
          <v-skeleton-loader class="top-stat-loader-card" type="article" />
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<style scoped lang="scss">
.top-stat-loader {
  position: relative;
}

.top-stat-loader-header {
  width: min(320px, 72%);
  margin: 0 auto 20px;
}

.top-stat-loader-grid {
  margin-top: 0;
}

.top-stat-loader-card {
  border-radius: 12px;
  min-height: 108px;
}
</style>
